import { ImportTypeProvider } from '@/api/admin/provider';
import { Button } from '@/components/ui/button';
import { ColumnDef } from '@tanstack/react-table';
import { ArrowUpDown } from 'lucide-react';

import { UpdateImportTypeProvider } from './sheet-update';

export const getColumns = (
	importTypeId: number,
): ColumnDef<ImportTypeProvider>[] => [
	{
		accessorKey: 'wsPrefixComplocProviderXrefId',
		header: ({ column }) => (
			<div className="text-right">
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
				>
					Provider XRef Id
					<ArrowUpDown />
				</Button>
			</div>
		),
		cell: ({ row }) => {
			return (
				<div className="text-right font-medium">
					{row.original.wsPrefixComplocProviderXrefId}
				</div>
			);
		},
	},
	{
		accessorKey: 'program',
		header: ({ column }) => (
			<div className="flex justify-center">
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
				>
					Program
					<ArrowUpDown />
				</Button>
			</div>
		),
		cell: ({ row }) => {
			return (
				<div className="flex justify-center whitespace-nowrap font-medium">
					{row.original.program}
				</div>
			);
		},
	},
	{
		accessorKey: 'providerName',
		header: ({ column }) => (
			<div className="flex justify-center">
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
				>
					Provider
					<ArrowUpDown />
				</Button>
			</div>
		),
		cell: ({ row }) => {
			return (
				<div className="flex justify-center whitespace-nowrap font-medium">
					{row.original.providerName}
				</div>
			);
		},
	},
	{
		accessorKey: 'prefix',
		header: ({ column }) => (
			<div className="flex justify-center">
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
				>
					Prefix
					<ArrowUpDown />
				</Button>
			</div>
		),
		cell: ({ row }) => {
			return (
				<div className="flex justify-center whitespace-nowrap font-medium">
					{row.original.prefix}
				</div>
			);
		},
	},
	{
		accessorKey: 'brandName',
		header: ({ column }) => (
			<div className="flex justify-center">
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
				>
					Company Location
					<ArrowUpDown />
				</Button>
			</div>
		),
		cell: ({ row }) => {
			return (
				<div className="flex justify-center whitespace-nowrap font-medium">
					{row.original.brandName}
				</div>
			);
		},
	},
	{
		id: 'actions',
		cell: ({ row }) => (
			<div>
				{
					<UpdateImportTypeProvider
						importTypeProvider={row.original}
						importTypeId={importTypeId}
					/>
				}
			</div>
		),
	},
];
